/* global axios */
import ApiClient from '../ApiClient';

class Analyzers extends ApiClient {
  constructor() {
    super('analysis/analyzers', { accountScoped: true });
  }

  create(data = {}) {
    return axios.post(this.url, { analyzer: data });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, { analyzer: data });
  }
}

export default new Analyzers();
